import { cn } from '@/lib/utils';

type StatusValue =
  | 'good'
  | 'warning'
  | 'critical'
  | 'neutral'
  | 'healthy'
  | 'at_risk'
  | 'pending'
  | 'in_progress'
  | 'done'
  | 'skipped'
  | 'high'
  | 'medium'
  | 'low';

const STATUS_CLASS: Record<StatusValue, string> = {
  good: 'text-[var(--domino-good)]',
  warning: 'text-[var(--domino-warning)]',
  critical: 'text-[var(--domino-critical)]',
  neutral: 'text-domino-inkSoft',
  healthy: 'text-[var(--domino-good)]',
  at_risk: 'text-[var(--domino-warning)]',
  pending: 'text-domino-inkSoft',
  in_progress: 'text-domino-aubergine',
  done: 'text-[var(--domino-good)]',
  skipped: 'text-domino-inkSoft',
  // Never red text (charter): the attention lives in the signal dot.
  high: 'text-domino-ink',
  medium: 'text-[var(--domino-warning)]',
  low: 'text-emerald-700',
};

const STATUS_LABEL: Record<StatusValue, string> = {
  good: 'Bon',
  warning: 'À vérifier',
  critical: 'Critique',
  neutral: 'Neutre',
  healthy: 'Sain',
  at_risk: 'À risque',
  pending: 'À faire',
  in_progress: 'En cours',
  done: 'Terminé',
  skipped: 'Ignoré',
  high: 'Haute',
  medium: 'Moyenne',
  low: 'Basse',
};

export const statusLabel = (status: string): string => {
  const key = (status in STATUS_LABEL ? status : null) as StatusValue | null;
  return key ? STATUS_LABEL[key] : status.replace(/_/g, ' ');
};

interface StatusBadgeProps {
  status: string;
  /** Overrides the default label (e.g. « Prioritaire » for a high priority). */
  label?: string;
  className?: string;
}

export const StatusBadge = ({ status, label, className }: StatusBadgeProps) => {
  const key = (status in STATUS_CLASS ? status : 'neutral') as StatusValue;
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 text-xs font-medium',
        STATUS_CLASS[key],
        className
      )}
    >
      <span className={cn('h-1.5 w-1.5 rounded-full', key === 'high' ? 'bg-domino-coral' : 'bg-current')} aria-hidden="true" />
      {label ?? statusLabel(status)}
    </span>
  );
};
